import request from 'services/axios';

export const getMyPosts = async (page: number, profile_type: string) => {
  const {data}: {data: IGetMyPosts} = await request.get(
    `/api/v2/market/my-posts?page=${page}&profile_type=${profile_type}`,
  );
  return data;
};
